import type { CleanupTypeVersion, WizardData } from '../types';

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Solo stale types: unused past the threshold and not owned by any wizard
 * lane, so nothing else will ever put admin eyes on them. Two sources:
 * - personal types outside any personal cluster
 * - AUTO-PROMOTED provider rows outside any divergent group — Layer 1
 *   would promote these sight-unseen into the shared catalog (the NECPAD
 *   walkthrough surfaced "…Copy Copy" no-template 1-visit rows exactly
 *   this way)
 * Org-scoped rows are excluded (they were shared before the wizard — the
 * catalog preview owns those). Types with upcoming appointments have a
 * future lastUsedAt and can never qualify.
 */
export const soloStaleTypes = (
  data: WizardData,
  weeks: number,
  now: Date = new Date()
): CleanupTypeVersion[] => {
  const inLane = new Set([
    ...data.personalClusters.flatMap((g) => g.versions.map((v) => v.id)),
    ...data.divergentGroups.flatMap((g) => g.versions.map((v) => v.id)),
  ]);
  const cutoff = now.getTime() - weeks * WEEK_MS;
  const stale = (t: CleanupTypeVersion): boolean =>
    !inLane.has(t.id) &&
    (!t.lastUsedAt || new Date(t.lastUsedAt).getTime() < cutoff);
  return [
    ...data.personalTypes.filter(stale),
    ...data.sharedTypes.filter(
      (t) => t.ownerScope !== 'organization' && stale(t)
    ),
  ].sort((a, b) => b.usage - a.usage);
};
